/* ===== Countdown ===== */
(function(){
  function target(){
    var now=new Date(),d=new Date(now),day=now.getDay(),add=(7-day)%7;
    d.setDate(now.getDate()+add);d.setHours(23,59,59,0);
    if(d<=now){d.setDate(d.getDate()+7);}return d;
  }
  function parseEnd(de){
    if(!de) return null;
    de=(''+de).trim();
    if(de.length<4) return null;
    var d=new Date(de);
    if(!isNaN(d.getTime())) return d;
    d=new Date(de.replace(' ','T'));            // "2026-08-16 23:59" -> ISO
    if(!isNaN(d.getTime())) return d;
    d=new Date(de.replace(/-/g,'/'));           // "2026-08-16" -> "2026/08/16"
    if(!isNaN(d.getTime())) return d;
    return null;
  }
  var cd=document.getElementById('countdown');
  if(cd){
    var end=parseEnd(cd.getAttribute('data-end'))||target();
    var ids=['cd-d','cd-h','cd-m','cd-s'];
    function tick(){
      var diff=Math.max(0,end-new Date()),s=Math.floor(diff/1000);
      var days=Math.floor(s/86400);s-=days*86400;var hrs=Math.floor(s/3600);s-=hrs*3600;
      var min=Math.floor(s/60),sec=s-min*60,p=function(n){return String(n).padStart(2,'0');};
      var e;
      if(e=document.getElementById('cd-d'))e.textContent=p(days);
      if(e=document.getElementById('cd-h'))e.textContent=p(hrs);
      if(e=document.getElementById('cd-m'))e.textContent=p(min);
      if(e=document.getElementById('cd-s'))e.textContent=p(sec);
    }
    tick();setInterval(tick,1000);
  }
})();

/* ===== Raffle popup ===== */
function openRaffle(){try{if(localStorage.getItem('dnRaffleSeen'))return;localStorage.setItem('dnRaffleSeen','1');}catch(e){}var m=document.getElementById('raffleModal');if(m)m.classList.add('show');}
function closeRaffle(){var m=document.getElementById('raffleModal');if(m)m.classList.remove('show');}
(function(){var m=document.getElementById('raffleModal');if(m){m.addEventListener('click',function(e){if(e.target===this)closeRaffle();});setTimeout(openRaffle,2000);}})();

/* ===== Before/After popup + slider (per-product images) ===== */
var baIndex=0, baCount=1;
function baRender(){
  var t=document.getElementById('baTrack');
  if(t)t.style.transform='translateX('+(-baIndex*100)+'%)';
  var dots=document.querySelectorAll('#baDots span');
  dots.forEach(function(d,i){d.classList.toggle('active',i===baIndex);});
}
function baGo(dir){baIndex=(baIndex+dir+baCount)%baCount;baRender();}
function baSet(i){baIndex=i;baRender();}
function baBuild(imgs){
  var track=document.getElementById('baTrack'), dots=document.getElementById('baDots');
  if(!track||!dots) return;
  track.innerHTML=''; dots.innerHTML='';
  if(!imgs||!imgs.length){imgs=[""];}
  baCount=imgs.length;
  imgs.forEach(function(src,i){
    var url=src||'';
    var slide=document.createElement('div'); slide.className='ba-slide';
    slide.innerHTML=
      '<div class="ba-frame imgslot"'+(url?' style="background-image:url('+url+');background-size:contain;background-repeat:no-repeat;background-position:center;"':'')+'></div>';
    track.appendChild(slide);
    var dot=document.createElement('span'); if(i===0)dot.className='active';
    dot.addEventListener('click',(function(idx){return function(){baSet(idx);};})(i));
    dots.appendChild(dot);
  });
}
function openBA(el){
  var card=el.closest('.card'), tEl=card?card.querySelector('.card-title'):null;
  var title=el.getAttribute('data-title')||(tEl?tEl.textContent.trim():'Before & After');
  document.getElementById('baTitle').textContent=title;
  var pairs=[];
  try{pairs=JSON.parse(el.getAttribute('data-ba')||'[]');}catch(e){pairs=[];}
  baBuild(pairs);
  baIndex=0; baRender();
  document.getElementById('baModal').classList.add('show');
}
function closeBA(){var m=document.getElementById('baModal');if(m)m.classList.remove('show');}
(function(){var m=document.getElementById('baModal');if(m)m.addEventListener('click',function(e){if(e.target===this)closeBA();});})();

/* ===== Prize carousel ===== */
function slidePrizes(dir){var t=document.getElementById('prizeTrack');if(t)t.scrollBy({left:dir*308,behavior:'smooth'});}

/* ===== Shop-row sliders (arrows scroll the row's .cards track) ===== */
function dnSlide(btn,dir){var w=btn.closest('.wrap');var t=w&&w.querySelector('.cards');if(t)t.scrollBy({left:dir*312,behavior:'smooth'});}

/* ===== AJAX cart: quick add + quick shop popup ===== */
function dnRoutes(){return window.DN_ROUTES||{add:'/cart/add.js',cart:'/cart.js'};}
function dnUpdateCount(c){var el=document.getElementById('dnCartCount');if(!el)return;el.textContent=c;el.classList.toggle('has',c>0);}
function dnRefreshCart(){fetch(dnRoutes().cart,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(d){dnUpdateCount(d.item_count);}).catch(function(){});}
function dnToast(msg){var t=document.getElementById('dnToast');if(!t){t=document.createElement('div');t.id='dnToast';t.className='dn-toast';document.body.appendChild(t);}t.textContent=msg||'Added to your bag';t.classList.add('show');clearTimeout(window.__dnToastT);window.__dnToastT=setTimeout(function(){t.classList.remove('show');},2200);}
function dnAddToCart(id,qty,cb){
  fetch(dnRoutes().add,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty})})
    .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
    .then(function(res){
      if(!res.ok){dnToast(res.d&&res.d.description?res.d.description:'Could not add to cart');if(cb)cb(false);return;}
      dnRefreshCart();dnToast('Added to your bag');if(cb)cb(true);
    }).catch(function(){dnToast('Could not add to cart');if(cb)cb(false);});
}
function quickAdd(btn){
  var id=btn.getAttribute('data-id');if(!id)return;
  var o=btn.textContent;btn.disabled=true;btn.textContent='Adding...';
  dnAddToCart(id,1,function(ok){btn.textContent=ok?'Added':o;setTimeout(function(){btn.textContent=o;btn.disabled=false;},1400);});
}
var shopState={variants:[],options:[],min:1,selected:[],handle:'',images:[],imgIndex:0};
function shopMoney(cents){return '$'+(cents/100).toFixed(2).replace(/\.00$/,'');}
function shopRoot(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';}
function openShop(el){
  var host=el.closest('[data-handle]');if(!host)return;
  var handle=host.getAttribute('data-handle');if(!handle)return;
  shopState.handle=handle;
  shopState.min=parseInt(host.getAttribute('data-min')||'1',10)||1;
  shopState.eventPrice=host.getAttribute('data-event')||'';
  shopState.eventReg=host.getAttribute('data-reg')||'';
  shopState.bundle=host.getAttribute('data-mixbundle')==='true';
  shopState.max=parseInt(host.getAttribute('data-max')||'0',10)||0;
  if(shopState.bundle&&shopState.min<2){shopState.min=10;}
  var howto=host.getAttribute('data-howto')||'';
  var hEl=document.getElementById('qvHowto');
  if(hEl){if(howto){hEl.textContent=howto;hEl.style.display='';}else{hEl.textContent='';hEl.style.display='none';}}
  var title=host.getAttribute('data-title')||'Product';
  // reset UI to loading state
  document.getElementById('shopTitle').textContent=title;
  document.getElementById('shopPrice').textContent='';
  document.getElementById('qvDesc').innerHTML='<span class="qv-loading">Loading...</span>';
  document.getElementById('shopOptions').innerHTML='';
  document.getElementById('qvMain').style.backgroundImage='';
  document.getElementById('qvThumbs').innerHTML='';
  var added=document.getElementById('shopAdded');if(added)added.style.display='none';
  var qi=document.getElementById('shopQtyInput');if(qi){qi.value=shopState.min;qi.min=shopState.min;if(shopState.max)qi.max=shopState.max;else qi.removeAttribute('max');}
  var mn=document.getElementById('shopMin');
  if(mn){var notes=[];if(shopState.min>1)notes.push('Minimum '+shopState.min+' per order.');if(shopState.max)notes.push('Limit '+shopState.max+' per customer.');mn.textContent=notes.join(' ');}
  document.getElementById('shopModal').classList.add('show');
  fetch(shopRoot()+'products/'+handle+'.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(p){shopFill(p);})
    .catch(function(){document.getElementById('qvDesc').innerHTML='<span class="qv-loading">Could not load details.</span>';});
}
function shopFill(p){
  shopState.variants=p.variants||[];
  shopState.options=p.options||[];
  document.getElementById('shopTitle').textContent=p.title||'';
  var desc=document.getElementById('qvDesc');if(desc)desc.innerHTML=p.description||'';
  var full=document.getElementById('qvFull');if(full)full.href=shopRoot()+'products/'+p.handle;
  // gallery
  var imgs=(p.images&&p.images.length?p.images:(p.featured_image?[p.featured_image]:[]));
  shopState.images=imgs; shopState.imgIndex=0;
  var main=document.getElementById('qvMain'),thumbs=document.getElementById('qvThumbs');
  if(main)main.style.backgroundImage=imgs[0]?('url('+imgs[0]+')'):'';
  var show=imgs.length>1;
  var prev=main?main.querySelector('.qv-prev'):null,next=main?main.querySelector('.qv-next'):null;
  if(prev)prev.style.display=show?'':'none';
  if(next)next.style.display=show?'':'none';
  if(thumbs){thumbs.innerHTML='';if(show){imgs.forEach(function(src,i){var t=document.createElement('div');t.className='qv-thumb imgslot'+(i===0?' active':'');t.style.backgroundImage='url('+src+')';t.addEventListener('click',function(){qvGoImage(i);});thumbs.appendChild(t);});}}
  var qtyWrap=document.getElementById('shopQtyWrap'),bTot=document.getElementById('qvBundleTotal');
  if(shopState.bundle){
    if(qtyWrap)qtyWrap.style.display='none';
    if(bTot)bTot.style.display='';
    buildBundlePicker(p);
  } else {
    if(qtyWrap)qtyWrap.style.display='';
    if(bTot)bTot.style.display='none';
    buildShopOptions();
  }
  shopMatch();
}
function buildBundlePicker(p){
  var wrap=document.getElementById('shopOptions');if(!wrap)return;wrap.innerHTML='';
  shopState.bundleQ={};
  (p.variants||[]).forEach(function(v){
    shopState.bundleQ[v.id]=0;
    var row=document.createElement('div');row.className='bundle-row';
    var nm=document.createElement('div');nm.className='bundle-name';nm.textContent=v.title||v.option1||'Shot';
    if(!v.available){nm.textContent+=' (sold out)';}
    var st=document.createElement('div');st.className='qty-stepper bundle-stepper';
    var minus=document.createElement('button');minus.type='button';minus.textContent='−';minus.addEventListener('click',(function(id){return function(){bundleStep(id,-1);};})(v.id));
    var inp=document.createElement('input');inp.type='number';inp.min='0';inp.value='0';inp.readOnly=true;inp.className='bundle-qty';inp.setAttribute('data-vid',v.id);
    var plus=document.createElement('button');plus.type='button';plus.textContent='+';plus.addEventListener('click',(function(id,av){return function(){if(av)bundleStep(id,1);};})(v.id,v.available));
    if(!v.available){plus.disabled=true;minus.disabled=true;}
    st.appendChild(minus);st.appendChild(inp);st.appendChild(plus);
    row.appendChild(nm);row.appendChild(st);
    wrap.appendChild(row);
  });
  bundleUpdate();
}
function bundleTotalCount(){var t=0;for(var k in shopState.bundleQ){t+=shopState.bundleQ[k];}return t;}
function bundleStep(vid,dir){
  var q=(shopState.bundleQ[vid]||0)+dir;if(q<0)q=0;shopState.bundleQ[vid]=q;
  var inp=document.querySelector('#shopOptions .bundle-qty[data-vid="'+vid+'"]');if(inp)inp.value=q;
  bundleUpdate();
}
function bundleUpdate(){
  var total=bundleTotalCount(),need=shopState.min||10;
  var tot=document.getElementById('qvBundleTotal');
  if(tot){
    if(total<need){tot.innerHTML='<b>'+total+'</b> of '+need+' selected &middot; add '+(need-total)+' more to unlock the price';}
    else{tot.innerHTML='<b>'+total+'</b> selected &middot; ready to add';}
  }
  var btn=document.getElementById('shopAddBtn');
  if(btn){if(total>=need){btn.disabled=false;btn.textContent='Add '+total+' to cart';}else{btn.disabled=true;btn.textContent='Choose '+need+' shots';}}
}
function qvGoImage(i){
  if(!shopState.images||!shopState.images.length)return;
  shopState.imgIndex=(i+shopState.images.length)%shopState.images.length;
  var src=shopState.images[shopState.imgIndex];
  var main=document.getElementById('qvMain');if(main)main.style.backgroundImage='url('+src+')';
  var thumbs=document.querySelectorAll('#qvThumbs .qv-thumb');thumbs.forEach(function(t,idx){t.classList.toggle('active',idx===shopState.imgIndex);});
}
function qvArrow(dir){qvGoImage((shopState.imgIndex||0)+dir);}
function closeShop(){var m=document.getElementById('shopModal');if(m)m.classList.remove('show');}
function shopOptName(o){return (typeof o==='string')?o:((o&&o.name)||'');}
function shopOptionValues(idx){
  var seen={},vals=[];
  shopState.variants.forEach(function(v){var val=v['option'+(idx+1)];if(val!=null&&!seen[val]){seen[val]=1;vals.push(val);}});
  return vals;
}
function buildShopOptions(){
  var wrap=document.getElementById('shopOptions');if(!wrap)return;wrap.innerHTML='';shopState.selected=[];
  if(shopState.variants.length<=1)return;
  var count=shopState.options.length||1;
  for(var idx=0;idx<count;idx++){
    (function(idx){
      var vals=shopOptionValues(idx);
      shopState.selected[idx]=vals[0];
      var field=document.createElement('div');field.className='shop-field';
      var lbl=document.createElement('label');lbl.textContent=shopOptName(shopState.options[idx])||('Option '+(idx+1));field.appendChild(lbl);
      var sel=document.createElement('select');sel.className='shop-select';sel.setAttribute('data-oi',idx);
      vals.forEach(function(v){var o=document.createElement('option');o.value=v;o.textContent=v;sel.appendChild(o);});
      sel.addEventListener('change',function(){shopState.selected[this.getAttribute('data-oi')*1]=this.value;shopMatch();});
      field.appendChild(sel);wrap.appendChild(field);
    })(idx);
  }
}
function shopCurrentVariant(){
  if(shopState.variants.length<=1)return shopState.variants[0]||null;
  return shopState.variants.find(function(v){
    for(var i=0;i<shopState.selected.length;i++){if(v['option'+(i+1)]!==shopState.selected[i])return false;}
    return true;
  })||null;
}
function shopMatch(){
  var pEl=document.getElementById('shopPrice'),btn=document.getElementById('shopAddBtn');
  if(shopState.bundle){
    if(pEl){pEl.innerHTML=shopState.eventPrice?(shopState.eventPrice+(shopState.eventReg?(' <s>'+shopState.eventReg+'</s>'):'')):'';}
    bundleUpdate();
    return;
  }
  var v=shopCurrentVariant();
  if(!v){if(pEl)pEl.textContent='';if(btn){btn.disabled=true;btn.textContent='Unavailable';}return;}
  if(pEl){
    var html;
    if(shopState.eventPrice){html=shopState.eventPrice+(shopState.eventReg?(' <s>'+shopState.eventReg+'</s>'):'');}
    else{html=shopMoney(v.price);if(v.compare_at_price&&v.compare_at_price>v.price){html+=' <s>'+shopMoney(v.compare_at_price)+'</s>';}}
    pEl.innerHTML=html;
  }
  if(btn){if(v.available){btn.disabled=false;btn.textContent='Add to cart';}else{btn.disabled=true;btn.textContent='Sold out';}}
}
function shopQty(dir){var qi=document.getElementById('shopQtyInput');if(!qi)return;var q=(parseInt(qi.value||shopState.min,10)||shopState.min)+dir;if(q<shopState.min)q=shopState.min;if(shopState.max&&q>shopState.max)q=shopState.max;qi.value=q;}
function shopQtyClamp(){var qi=document.getElementById('shopQtyInput');if(!qi)return;var q=parseInt(qi.value,10);if(isNaN(q)||q<shopState.min)q=shopState.min;if(shopState.max&&q>shopState.max)q=shopState.max;qi.value=q;}
function dnAddItems(items,cb){
  fetch(dnRoutes().add,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
    .then(function(res){
      if(!res.ok){dnToast(res.d&&res.d.description?res.d.description:'Could not add to cart');if(cb)cb(false);return;}
      dnRefreshCart();dnToast('Added to your bag');if(cb)cb(true);
    }).catch(function(){dnToast('Could not add to cart');if(cb)cb(false);});
}
function shopAdd(){
  if(shopState.bundle){
    var items=[],total=bundleTotalCount(),need=shopState.min||10;
    for(var k in shopState.bundleQ){if(shopState.bundleQ[k]>0)items.push({id:parseInt(k,10),quantity:shopState.bundleQ[k]});}
    if(total<need||!items.length)return;
    var bb=document.getElementById('shopAddBtn'),bo=bb.textContent;bb.disabled=true;bb.textContent='Adding...';
    dnAddItems(items,function(ok){
      if(ok){var ad=document.getElementById('shopAdded');if(ad)ad.style.display='block';bb.textContent='Added';setTimeout(function(){closeShop();bb.disabled=false;bundleUpdate();},1100);}
      else{bb.disabled=false;bb.textContent=bo;}
    });
    return;
  }
  var v=shopCurrentVariant();if(!v)return;
  var qi=document.getElementById('shopQtyInput'),qty=parseInt(qi&&qi.value||shopState.min,10);if(qty<shopState.min)qty=shopState.min;
  if(shopState.max&&qty>shopState.max)qty=shopState.max;
  var btn=document.getElementById('shopAddBtn'),o=btn.textContent;btn.disabled=true;btn.textContent='Adding...';
  var done=function(ok){
    if(ok){var added=document.getElementById('shopAdded');if(added)added.style.display='block';btn.textContent='Added';setTimeout(function(){closeShop();btn.disabled=false;btn.textContent='Add to cart';},1100);}
    else{btn.disabled=false;btn.textContent=o;}
  };
  if(shopState.max){
    fetch(dnRoutes().cart,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var existing=0;(cart.items||[]).forEach(function(it){if(it.id===v.id)existing+=it.quantity;});
      var allowed=shopState.max-existing;
      if(allowed<=0){dnToast('Limit '+shopState.max+' per customer — already in your bag');btn.disabled=false;btn.textContent=o;return;}
      dnAddToCart(v.id,Math.min(qty,allowed),done);
    }).catch(function(){dnAddToCart(v.id,qty,done);});
    return;
  }
  dnAddToCart(v.id,qty,done);
}
(function(){var m=document.getElementById('shopModal');if(m)m.addEventListener('click',function(e){if(e.target===this)closeShop();});})();

/* ===== Copy promo code ===== */
function copyCode(){
  var codeEl=document.querySelector('.pc-code'), el=document.getElementById('pcCopy');
  var code=codeEl?codeEl.textContent.trim():'';
  try{navigator.clipboard.writeText(code);}catch(e){}
  if(el){var o=el.textContent;el.textContent='Copied';setTimeout(function(){el.textContent=o;},1600);}
}

/* ===== Escape closes modals ===== */
document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeBA();closeRaffle();closeShop();}});